var _rect, _path, _path2, _path3, _rect2, _rect3, _g, _rect4, _rect5, _g2, _rect6, _rect7, _g3, _path4, _rect8, _rect9, _g4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoCall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 184,
    viewBox: "0 0 327 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_4393)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_4393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 327,
    height: 184
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 184,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_4393)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.3677 135.08V45.2396C96.3677 42.2081 98.5921 39.7828 101.338 39.7828H225.662C228.39 39.7828 230.632 42.2323 230.632 45.2396V135.083L96.3677 135.08Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.711 47.4193H224.29V128.541H102.711V47.4193Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1427 144.217H241.858C246.34 144.217 249.976 140.131 249.976 135.089H77.0239C77.0239 140.125 80.6575 144.217 85.1427 144.217Z",
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.511,
    y: 47.1155,
    width: 61.414,
    height: 40.7133,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_239_4393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 47,
    width: 62,
    height: 41
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 47.1155,
    width: 61.414,
    height: 40.6487,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_239_4393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.955 106.238L150.873 98.9302C150.773 90.091 148.549 85.2647 145.64 82.506C142.613 79.2605 137.344 78.1665 131.344 78.1665C125.344 78.1665 120.075 79.2647 117.049 82.506C114.143 85.2657 111.92 90.091 111.816 98.9302L111.746 106.238H150.955Z",
    fill: "#0A882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.781 79.5746H126.92V106.241H135.781V79.5746Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.35 84.8522C132.525 84.8522 133.652 84.3853 134.483 83.5542C135.314 82.7232 135.781 81.596 135.781 80.4205V72.1184H126.92V80.4205C126.92 81.0025 127.035 81.5788 127.257 82.1164C127.48 82.6541 127.806 83.1426 128.217 83.5542C128.629 83.9657 129.117 84.2921 129.655 84.5148C130.192 84.7375 130.768 84.8522 131.35 84.8522Z",
    fill: "#D99068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.012 54.5678C139.012 53.6418 138.737 52.7367 138.223 51.9668C137.709 51.197 136.977 50.597 136.122 50.2429C135.267 49.8887 134.326 49.7963 133.418 49.9772C132.51 50.1582 131.677 50.6044 131.022 51.2594C130.368 51.9145 129.923 52.7489 129.743 53.6572C129.563 54.5654 129.656 55.5067 130.011 56.3619C130.366 57.2172 130.966 57.9479 131.736 58.4617C132.506 58.9756 133.411 59.2494 134.337 59.2486C135.578 59.2486 136.768 58.7554 137.645 57.8776C138.523 56.9998 139.016 55.8092 139.016 54.5678",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.689 62.5433V68.5841C123.689 72.8765 127.203 78.3508 131.498 78.2692C135.661 78.1907 139.012 72.9183 139.012 68.7348V62.5433C139.012 60.5106 138.205 58.5611 136.768 57.1237C135.331 55.6863 133.382 54.8788 131.35 54.8788V54.8788C129.318 54.8791 127.369 55.6867 125.933 57.124C124.496 58.5614 123.689 60.5107 123.689 62.5433V62.5433Z",
    fill: "#E2A88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.508 57.4217C136.804 56.471 135.89 55.6962 134.837 55.1579C133.784 54.6195 132.62 54.3323 131.438 54.3186C127.175 54.2694 123.688 57.8583 123.688 62.1213V64.1199C127.634 63.6999 131.34 62.0213 134.258 59.3323L134.376 59.2276L139.014 64.5502V61.9852C139.017 60.3415 138.488 58.7409 137.508 57.4217V57.4217Z",
    fill: "#333333"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.511,
    y: 87.949,
    width: 61.414,
    height: 40.7133,
    fill: "#E7E3E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_239_4393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 87,
    width: 62,
    height: 42
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 87.949,
    width: 61.414,
    height: 40.6487,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_239_4393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.955 147.071L150.873 139.764C150.773 130.924 148.549 126.098 145.64 123.34C142.613 120.094 137.344 119 131.344 119C125.344 119 120.075 120.098 117.049 123.34C114.143 126.099 111.92 130.924 111.816 139.764L111.746 147.071H150.955Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.767 117.651C142.264 118.425 141.799 119.142 141.441 119.806C139.927 122.617 137.544 120.277 135.865 118.629C135.405 118.177 134.997 117.777 134.676 117.55L130.353 119.23C129.392 119.497 124.934 120.218 123.186 120.321C122.36 120.453 121.567 120.395 120.835 120.124C116.76 118.617 116.097 111.089 119.354 103.309C120.536 100.486 122.071 98.0179 123.743 96.0908L123.751 96.0273C123.751 96.0273 125.422 93.6718 128.267 92.4145C129.185 91.9688 130.089 91.7181 130.946 91.6897C133.792 91.3928 137.334 92.492 141.298 96.8954C149.98 106.54 145.724 113.096 142.767 117.651Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.781 120.408H126.92V147.074H135.781V120.408Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.35 125.686C132.525 125.686 133.652 125.219 134.483 124.388C135.314 123.557 135.781 122.429 135.781 121.254V112.952H126.92V121.254C126.92 121.836 127.035 122.412 127.257 122.95C127.48 123.488 127.806 123.976 128.217 124.388C128.629 124.799 129.117 125.126 129.655 125.348C130.192 125.571 130.768 125.686 131.35 125.686Z",
    fill: "#D99068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.689 103.377C123.689 103.377 123.689 107.811 123.689 109.418C123.689 111.024 127.203 119.184 131.498 119.103C135.661 119.024 139.034 112.249 139.012 109.568C138.989 106.888 139.012 103.377 139.012 103.377C139.012 101.344 138.205 99.3945 136.768 97.9572C135.331 96.5198 133.382 95.7123 131.35 95.7123C129.318 95.7126 127.369 96.5202 125.933 97.9575C124.496 99.3949 123.689 101.344 123.689 103.377Z",
    fill: "#E2A88A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.19221,
    cy: 5.83907,
    rx: 9.19221,
    ry: 5.83907,
    transform: "matrix(0.786417 -0.617696 0.617436 0.786621 119.133 100.894)",
    fill: "#333333"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 163.463,
    y: 47.1155,
    width: 61.414,
    height: 40.7133,
    fill: "#FAF6F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_239_4393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 47,
    width: 62,
    height: 41
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.462,
    y: 47.1155,
    width: 61.414,
    height: 40.6487,
    fill: "#FAF6F3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_239_4393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.907 106.238L211.825 98.9302C211.725 90.091 209.501 85.2647 206.592 82.506C203.565 79.2605 198.296 78.1665 192.296 78.1665C186.296 78.1665 181.027 79.2647 178.001 82.506C175.095 85.2657 172.873 90.091 172.768 98.9302L172.698 106.238H211.907Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.733 79.5746H187.872V106.241H196.733V79.5746Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.302 84.8522C193.477 84.8522 194.604 84.3853 195.435 83.5542C196.266 82.7232 196.733 81.596 196.733 80.4205V72.1184H187.872V80.4205C187.872 81.0025 187.987 81.5788 188.209 82.1164C188.432 82.6541 188.758 83.1426 189.17 83.5542C189.581 83.9657 190.069 84.2921 190.607 84.5148C191.144 84.7375 191.72 84.8522 192.302 84.8522Z",
    fill: "#D99068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.641 62.5432V70.4316C184.641 74.724 188.155 78.3507 192.451 78.2691C196.613 78.1905 199.964 74.7659 199.964 70.5824V62.5432C199.964 60.5104 199.157 58.5609 197.72 57.1236C196.283 55.6862 194.334 54.8787 192.302 54.8787C190.27 54.8789 188.322 55.6866 186.885 57.1239C185.448 58.5613 184.641 60.5106 184.641 62.5432Z",
    fill: "#E2A88A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.749 56.4189C202.626 56.5809 204.098 58.1559 204.098 60.0748C204.098 61.1894 203.601 62.188 202.817 62.861C203.597 63.4717 204.098 64.422 204.098 65.4895C204.098 67.3319 202.605 68.8255 200.763 68.8255C198.921 68.8255 197.428 67.3319 197.428 65.4895L197.428 65.4686C196.769 65.1803 196.22 64.6848 195.865 64.0644C195.04 64.6954 193.952 65.0789 192.759 65.0789C192.489 65.0789 192.225 65.0592 191.967 65.0215C191.295 65.8694 190.256 66.4133 189.091 66.4133C188.725 66.4133 188.372 66.3598 188.039 66.2602C187.444 67.5043 186.175 68.3636 184.704 68.3636C182.664 68.3636 181.01 66.7092 181.01 64.6683C181.01 64.0294 181.172 63.4284 181.457 62.9041C181.015 62.2977 180.753 61.5504 180.753 60.742C180.753 59.0604 181.884 57.6429 183.427 57.209C183.529 55.2739 185.13 53.7363 187.09 53.7363C187.544 53.7363 187.979 53.8189 188.381 53.9701C188.939 52.6561 190.241 51.7346 191.759 51.7346C193.176 51.7346 194.405 52.5382 195.016 53.7146C195.607 53.3075 196.323 53.0691 197.095 53.0691C199.013 53.0691 200.587 54.542 200.749 56.4189Z",
    fill: "#333333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 163.463,
    y: 87.949,
    width: 61.414,
    height: 40.7133,
    fill: "#F4F0EE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_239_4393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 87,
    width: 62,
    height: 42
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 163.462,
    y: 87.949,
    width: 61.414,
    height: 40.6487,
    fill: "#FAF6F3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_239_4393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.907 147.071L211.825 139.764C211.725 130.924 209.501 126.098 206.592 123.339C203.565 120.094 198.296 119 192.296 119C186.296 119 181.027 120.098 178.001 123.339C175.095 126.099 172.873 130.924 172.768 139.764L172.698 147.071H211.907Z",
    fill: "#FEBD50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.733 120.408H187.872V147.074H196.733V120.408Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.302 125.686C193.477 125.686 194.604 125.219 195.435 124.388C196.266 123.557 196.733 122.429 196.733 121.254V112.952H187.872V121.254C187.872 121.836 187.987 122.412 188.209 122.95C188.432 123.488 188.758 123.976 189.17 124.388C189.581 124.799 190.069 125.126 190.607 125.348C191.144 125.571 191.72 125.686 192.302 125.686Z",
    fill: "#D99068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.703 105.694V112.548C184.703 116.278 188.304 119.429 192.705 119.358C196.969 119.29 200.403 116.314 200.403 112.679V105.694C200.403 103.928 199.576 102.234 198.104 100.985C196.631 99.7365 194.635 99.0349 192.553 99.0349C190.471 99.0352 188.474 99.7369 187.002 100.986C185.53 102.235 184.703 103.928 184.703 105.694Z",
    fill: "#E2A88A"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.429 105.04L184.704 111.969C184.704 111.969 184.242 110.121 183.78 107.811C183.347 105.645 182.395 102.73 182.395 102.73L181.472 99.9588L186.089 98.1111C186.089 98.1111 184.464 97.7748 183.78 97.1873C183.097 96.5998 182.588 95.1024 182.588 95.1024H190.795C190.795 95.1024 190.909 93.2942 191.426 92.2935C192.06 91.0655 193.951 89.7966 193.951 89.7966L195.529 92.9177L197.107 97.2872C197.107 97.2872 199.048 96.4575 200.264 96.0387C201.517 95.6068 203.42 95.1024 203.42 95.1024C203.42 95.1024 203.612 97.8364 203.104 99.4719C202.651 100.932 201.21 102.905 201.21 102.905C201.21 102.905 202.789 102.905 203.578 103.217C204.367 103.529 205.945 103.529 205.945 103.529L201.21 106.65C201.21 106.65 201.573 111.26 201.21 111.332C200.848 111.404 200.264 111.698 200.264 111.332C200.264 109.147 199.019 105.04 199.019 105.04C193.016 106.65 191.169 105.964 185.429 105.04Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_4393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 184,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-call.54dfbecd755affdbe2def85e1b22afcd.svg";